// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Error banner styles */
.error-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  margin-bottom: 24px;
  background-color: #fef3cd;
  border: 1px solid #fbbf24;
  border-radius: 8px;
  color: #92400e;
}

.error-banner .error-icon {
  font-size: 16px;
}

.retry-link {
  background: none;
  border: none;
  color: #1d4ed8;
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
  padding: 0;
  margin-left: auto;
}

.retry-link:hover {
  color: #1e40af;
  text-decoration: none;
}

.retry-link:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
  border-radius: 2px;
}

/* Sync option card accessibility improvements */
.sync-option-card {
  cursor: pointer;
  transition: all 0.2s ease;
}

.sync-option-card:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

.sync-option-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Rest of your existing CSS styles... */
.choose-sync {
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background: #fff;
}

.choose-sync-header {
  text-align: center;
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}

.choose-sync-header h1 {
  font-size: 2.5rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1rem;
}

.choose-sync-header p {
  font-size: 1.1rem;
  color: #6b7280;
  margin-bottom: 0.5rem;
}

.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 1rem;
}

.error-container .error-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.retry-button {
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  /* margin-top: 1rem; */
}

.sync-options {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.sync-option-card {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.sync-option-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.sync-option-card.selected {
  border-color: #3b82f6;
  background: #f0f9ff;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.option-radio {
  flex-shrink: 0;
}

.option-radio input[type="radio"] {
  width: 20px;
  height: 20px;
  accent-color: #3b82f6;
}

.option-icon {
  flex-shrink: 0;
  color: #6b7280;
}

.option-content {
  flex: 1 1;
}

.option-title {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.75rem;
}

.option-description {
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 0.75rem;
}

.option-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.sync-type {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
}

.sync-type.bidirectional {
  background: #dbeafe;
  color: #1e40af;
}

.sync-type.unidirectional {
  background: #fef3c7;
  color: #92400e;
}

.direction-arrow {
  color: #6b7280;
  display: flex;
  align-items: center;
}

.direction-arrow.bidirectional {
  color: #3b82f6;
}

.settings-note {
  text-align: center;
  margin-bottom: 2rem;
}

.settings-note p {
  color: #6b7280;
  font-size: 0.9rem;
  margin: 0;
}

.actions-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb;
}

.back-button {
  background: #f9fafb;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.back-button:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.continue-button {
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.continue-button:hover:not(:disabled) {
  background: #2563eb;
}

.continue-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .choose-sync {
    padding: 1rem;
  }

  .sync-option-card {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .option-title {
    flex-direction: column;
    gap: 0.5rem;
  }

  .actions-section {
    flex-direction: column;
    gap: 1rem;
  }

  .back-button,
  .continue-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector-Screen/ChooseSync/ChooseSync.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8EAA8E;EAC9E,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* Error banner styles */\n.error-banner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  margin-bottom: 24px;\n  background-color: #fef3cd;\n  border: 1px solid #fbbf24;\n  border-radius: 8px;\n  color: #92400e;\n}\n\n.error-banner .error-icon {\n  font-size: 16px;\n}\n\n.retry-link {\n  background: none;\n  border: none;\n  color: #1d4ed8;\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: inherit;\n  padding: 0;\n  margin-left: auto;\n}\n\n.retry-link:hover {\n  color: #1e40af;\n  text-decoration: none;\n}\n\n.retry-link:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n\n/* Sync option card accessibility improvements */\n.sync-option-card {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.sync-option-card:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n.sync-option-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Rest of your existing CSS styles... */\n.choose-sync {\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 2rem;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  background: #fff;\n}\n\n.choose-sync-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n}\n\n.choose-sync-header h1 {\n  font-size: 2.5rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 1rem;\n}\n\n.choose-sync-header p {\n  font-size: 1.1rem;\n  color: #6b7280;\n  margin-bottom: 0.5rem;\n}\n\n.loading-container,\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 1rem;\n}\n\n.error-container .error-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.retry-button {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  /* margin-top: 1rem; */\n}\n\n.sync-options {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.sync-option-card {\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 2rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.sync-option-card:hover {\n  border-color: #3b82f6;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);\n}\n\n.sync-option-card.selected {\n  border-color: #3b82f6;\n  background: #f0f9ff;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);\n}\n\n.option-radio {\n  flex-shrink: 0;\n}\n\n.option-radio input[type=\"radio\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: #3b82f6;\n}\n\n.option-icon {\n  flex-shrink: 0;\n  color: #6b7280;\n}\n\n.option-content {\n  flex: 1;\n}\n\n.option-title {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0.75rem;\n}\n\n.option-description {\n  color: #6b7280;\n  line-height: 1.6;\n  margin-bottom: 0.75rem;\n}\n\n.option-meta {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.sync-type {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.sync-type.bidirectional {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.sync-type.unidirectional {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.direction-arrow {\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n}\n\n.direction-arrow.bidirectional {\n  color: #3b82f6;\n}\n\n.settings-note {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.settings-note p {\n  color: #6b7280;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.actions-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 2rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.back-button {\n  background: #f9fafb;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.back-button:hover {\n  background: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.continue-button {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.continue-button:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.continue-button:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .choose-sync {\n    padding: 1rem;\n  }\n\n  .sync-option-card {\n    flex-direction: column;\n    text-align: center;\n    gap: 1rem;\n  }\n\n  .option-title {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .actions-section {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .back-button,\n  .continue-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
